import { render, staticRenderFns } from "./presAddSport.vue?vue&type=template&id=6c33f868&scoped=true"
import script from "./presAddSport.vue?vue&type=script&lang=ts"
export * from "./presAddSport.vue?vue&type=script&lang=ts"
import style0 from "./presAddSport.vue?vue&type=style&index=0&id=6c33f868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33f868",
  null
  
)

export default component.exports